module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"evento":"evento","lanzamiento":"lanzamiento","novedad":"novedad","noticia":"noticia"},"en":{"evento":"event","lanzamiento":"launch","novedad":"novelty","noticia":"news"},"pt":{"eveeventont":"evento","lanzamiento":"lançar","novedad":"novidade","noticia":"Notícias"}}')
  delete Component.options._Ctor
}
